import { MAILTO, UPGRADE_LINK } from '../utils/shared/constants';
import { useInstanceData } from '../hooks/useInstanceData';
import { Box, Button, Text } from '@wix/design-system';

interface Props {
    className?: string;
    location: 'settings' | 'dashboard';
}

export default function TrialInfo(props: Props) {
    const { instanceData, onTrial, daysLeft, trialEnded } = useInstanceData();

    if (!instanceData.instanceId || !onTrial) {
        return null;
    }

    const upgradeLink = `${UPGRADE_LINK}${instanceData.instanceId}`;
    return <Box direction='vertical' gap="12px" className={`p-3 ${props.className}`}>
        {trialEnded
            ? <Text>Your trial has ended!</Text>
            : <Text>There are <Text skin='primary'>{daysLeft}</Text> days left on your trial!</Text>
        }
        <div>
            <a href={upgradeLink} target='_blank' rel='noreferrer'>
                <Button skin='premium'>Upgrade</Button>
            </a>
        </div>
        <Text size='tiny'>-- <a href={MAILTO}>Share</a> your feedback for a chance of extended trial --</Text>
    </Box >
}
